export default {
  components: {},
  props: ["route"],
  data: () => ({
    pkPro: 1,
    distanceMax: 12,
    limit: true,
    isFrontPage: false,
    lat: null,
    lng: null,
    full_address: "", 
    locality: "",
  }),
  created() {
    if (this.$route.query.locality)
      this.full_address = this.$route.query.locality;
  },
  methods: {
    setAddress(place) {
      this.full_address = place.formatted_address;
      if (this.full_address) {
        // this.full_address = place;
        var found = place.address_components.find(function (element) {
          var el = element.types.find(function (el) {
            return el === "locality";
          });
          return el ? el.length : 0;
        });
      }
      this.locality =
        found != undefined && found.long_name != null ?
        found.long_name :
        place.address_components[0].long_name;
      if (place.formatted_address) {
        this.lat = place.geometry.location.lat();
        this.lng = place.geometry.location.lng();
      }
    },
    searchLocation(input) {
      return new Promise(() => {
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
          address: input
        }, (results, status) => {
          if (status === "OK") {
            resolve({
              lat: results[0].geometry.location.lat(),
              lng: results[0].geometry.location.lng(),
            });
          } else {
            resolve({
              lat: null,
              lng: null
            });
          }
        });
      });
    },
    checkLocationThenSearch() {
      const vue = this;
      // vue.$el[0].value  && (this.locality = vue.$el[0].value);
      this.locality = vue.$el[0].value
      var route = "";
      var isPublicZone = /^\/public/.test(this.$route.path);
      var companyParam = this.$route.params.company;
      if (isPublicZone) {
        route = `/public/${companyParam}/jobs`;
      } else {
        route = `/candidate/${companyParam}/jobs-candidat`;
      }

      const isAbleToDisplayGenericMissions = [
        "browse-jobs",
        "candidate-browse-jobs",
        "candidate-browse-missions",
        "jobs",
      ].includes(this.$route.name);
      var geocoder = new google.maps.Geocoder();
      geocoder.geocode({
        address: vue.locality
      }, (results, status) => {
        if (status === "OK" && (vue.lat === null || vue.lng === null)) {
          vue.lat = results[0].geometry.location.lat();
          vue.lng = results[0].geometry.location.lng();
        }
        if (!results) {
          this.lat = '';
          this.lng = '';
        }
        if (!isAbleToDisplayGenericMissions) {
          vue.$router.push({
            path: route,
            query: {
              locality: this.locality,
              lat: vue.lat,
              lng: vue.lng,
            },
          });
        } else {
          vue.$router.replace({
            path: route,
            query: {
              locality: vue.locality,
              lat: vue.lat,
              lng: vue.lng,
            },
          });
          // vue.emitSearchGenericMissions();
          vue.$emit("triggerSearch", vue.lat, vue.lng);
          vue.full_address = vue.locality;
        }
      });
    },

    emitSearchGenericMissions() {
      const isAbleToDisplayGenericMissions = [
        "browse-jobs",
        "candidate-browse-jobs",
        "candidate-browse-missions",
        "jobs",
      ].includes(this.$route.name);
      if (isAbleToDisplayGenericMissions) {
        this.$emit("triggerSearch", this.lat, this.lng);
      } else {
        var route = "";
        var isPublicZone = /^\/public/.test(this.$route.path);
        var companyParam = this.$route.params.company;
        if (isPublicZone) {
          route = `/public/${companyParam}/jobs`;
        } else {
          route = `/candidate/${companyParam}/jobs-candidat`;
        }

        this.$router.push({
          path: route,
          query: {
            locality: this.locality,
            lat: this.lat,
            lng: this.lng,
          },
        });
      }
    },
  },
};